import cn from 'classnames'
import { HTMLAttributes, memo } from 'react'

import styles from './Cart.module.css'

const CartHeader = memo(({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex', styles.cartHeader, className)} {...props}>
    {children}
  </div>
))

export default CartHeader
